export default class AdminTrendService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(params) {
    return this.$http.get('/api/report/data_a_y_admin', {
      params: {
        ...params
      }
    }).then(r => r.data);
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/admin-trend/admin-trend.service.js